"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _BrightCove = require("./BrightCove");
var _Facebook = require("./Facebook");
var _InactiveStream = require("./InactiveStream");
var _Linkedin = require("./Linkedin");
var _Play = require("./Play");
var _Recording = require("./Recording");
var _RecordingCircle = require("./RecordingCircle");
var _RecordingCircleActive = require("./RecordingCircleActive");
var _RecordingEllipse = require("./RecordingEllipse");
var _Rss = require("./Rss");
var _Rtmp = require("./Rtmp");
var _Stop = require("./Stop");
var _StreamingEllipse = require("./StreamingEllipse");
var _Twitch = require("./Twitch");
var _Twitter = require("./Twitter");
var _Vimeo = require("./Vimeo");
var _Wowza = require("./Wowza");
var _Youtube = require("./Youtube");
var _GridLightFocus = require("./GridLightFocus");
var _GridLightHover = require("./GridLightHover");
var _GridLightPress = require("./GridLightPress");
var _GridLightDefault = require("./GridLightDefault");
var _GridLightDisabled = require("./GridLightDisabled");
var _SideBySideLightFocus = require("./SideBySideLightFocus");
var _SideBySideLightHover = require("./SideBySideLightHover");
var _SideBySideLightPress = require("./SideBySideLightPress");
var _FeaturedMediaLightFocus = require("./FeaturedMediaLightFocus");
var _FeaturedMediaLightHover = require("./FeaturedMediaLightHover");
var _FeaturedMediaLightPress = require("./FeaturedMediaLightPress");
var _SideBySideLightDefault = require("./SideBySideLightDefault");
var _FeaturedScreenLightFocus = require("./FeaturedScreenLightFocus");
var _FeaturedScreenLightHover = require("./FeaturedScreenLightHover");
var _FeaturedScreenLightPress = require("./FeaturedScreenLightPress");
var _SideBySideLightDisabled = require("./SideBySideLightDisabled");
var _FeaturedMediaLightDefault = require("./FeaturedMediaLightDefault");
var _FeaturedMediaLightDisabled = require("./FeaturedMediaLightDisabled");
var _FeaturedScreenLightDefault = require("./FeaturedScreenLightDefault");
var _FeaturedPresenterLightFocus = require("./FeaturedPresenterLightFocus");
var _FeaturedPresenterLightHover = require("./FeaturedPresenterLightHover");
var _FeaturedPresenterLightPress = require("./FeaturedPresenterLightPress");
var _FeaturedScreenLightDisabled = require("./FeaturedScreenLightDisabled");
var _FeaturedPresenterLightDefault = require("./FeaturedPresenterLightDefault");
var _FeaturedPresenterLightDisabled = require("./FeaturedPresenterLightDisabled");
var svgs = {
  BrightCove: _BrightCove.BrightCove,
  Facebook: _Facebook.Facebook,
  InactiveStream: _InactiveStream.InactiveStream,
  Linkedin: _Linkedin.Linkedin,
  Play: _Play.Play,
  Recording: _Recording.Recording,
  RecordingCircle: _RecordingCircle.RecordingCircle,
  RecordingCircleActive: _RecordingCircleActive.RecordingCircleActive,
  RecordingEllipse: _RecordingEllipse.RecordingEllipse,
  Rss: _Rss.Rss,
  Rtmp: _Rtmp.Rtmp,
  Stop: _Stop.Stop,
  StreamingEllipse: _StreamingEllipse.StreamingEllipse,
  Twitch: _Twitch.Twitch,
  Twitter: _Twitter.Twitter,
  Vimeo: _Vimeo.Vimeo,
  Wowza: _Wowza.Wowza,
  Youtube: _Youtube.Youtube,
  GridLightFocus: _GridLightFocus.GridLightFocus,
  GridLightHover: _GridLightHover.GridLightHover,
  GridLightPress: _GridLightPress.GridLightPress,
  GridLightDefault: _GridLightDefault.GridLightDefault,
  GridLightDisabled: _GridLightDisabled.GridLightDisabled,
  SideBySideLightFocus: _SideBySideLightFocus.SideBySideLightFocus,
  SideBySideLightHover: _SideBySideLightHover.SideBySideLightHover,
  SideBySideLightPress: _SideBySideLightPress.SideBySideLightPress,
  FeaturedMediaLightFocus: _FeaturedMediaLightFocus.FeaturedMediaLightFocus,
  FeaturedMediaLightHover: _FeaturedMediaLightHover.FeaturedMediaLightHover,
  FeaturedMediaLightPress: _FeaturedMediaLightPress.FeaturedMediaLightPress,
  SideBySideLightDefault: _SideBySideLightDefault.SideBySideLightDefault,
  FeaturedScreenLightFocus: _FeaturedScreenLightFocus.FeaturedScreenLightFocus,
  FeaturedScreenLightHover: _FeaturedScreenLightHover.FeaturedScreenLightHover,
  FeaturedScreenLightPress: _FeaturedScreenLightPress.FeaturedScreenLightPress,
  SideBySideLightDisabled: _SideBySideLightDisabled.SideBySideLightDisabled,
  FeaturedMediaLightDefault: _FeaturedMediaLightDefault.FeaturedMediaLightDefault,
  FeaturedMediaLightDisabled: _FeaturedMediaLightDisabled.FeaturedMediaLightDisabled,
  FeaturedScreenLightDefault: _FeaturedScreenLightDefault.FeaturedScreenLightDefault,
  FeaturedPresenterLightFocus: _FeaturedPresenterLightFocus.FeaturedPresenterLightFocus,
  FeaturedPresenterLightHover: _FeaturedPresenterLightHover.FeaturedPresenterLightHover,
  FeaturedPresenterLightPress: _FeaturedPresenterLightPress.FeaturedPresenterLightPress,
  FeaturedScreenLightDisabled: _FeaturedScreenLightDisabled.FeaturedScreenLightDisabled,
  FeaturedPresenterLightDefault: _FeaturedPresenterLightDefault.FeaturedPresenterLightDefault,
  FeaturedPresenterLightDisabled: _FeaturedPresenterLightDisabled.FeaturedPresenterLightDisabled
};
var _default = exports["default"] = svgs;